import React from 'react'
import ReactDOM from 'react-dom'
import NavLink from './NavLink'
import Link from 'gatsby-link';
import styled from 'styled-components'

import config from '../config'
import { device } from '../media'

import FadeIn from './FadeIn'
import MailToLink from './MailToLink'
import logo from '../assets/first-principle-logo.png'

const Logo = styled.img`
  max-width: 40.1041667%;
  min-width: 180px;
  margin: 0;
`

const StyledAside = styled.div`
  display: none;
  @media ${device.mobile} {
    display: block;
    margin: 2.4994rem auto;
    padding: 0.25em 0.5em 0;
    padding-top: 0;
    position: fixed;
    top: 0;
    width: 40%;
    text-align: center;
  }
`

const VerticalLink = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  transform: rotate(90deg);
  transform-origin: 0 0;
  line-height: 1;
  font-size: 0.391076115rem
  h2 {
    font-size: 0.391076115rem
    font-weight: 400;
  }
  h2:first-child {
    margin-right: 58px;
  }
  h2:last-child {
    margin: 0;
  }
`

class VerticalLinksComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  findDOMNode() {
    return ReactDOM.findDOMNode(this)
  }

  setupVerticalLinks = () => {
    const el = this.findDOMNode()
    const _this = this
    el.style.display = 'block'
    setTimeout(function(){      
      const coords = el.getBoundingClientRect()
      const elWidth = coords.width
      const elHeight = coords.height
      const logoLeft = document.getElementById('logo').getBoundingClientRect().left
      el.style.marginBottom = elHeight + 52 + "px"
      el.style.marginLeft = elWidth + logoLeft + "px"
    })
  }

  componentDidMount = () => {
    const el = this.findDOMNode()
    const _this = this
    
    let timeout = false
    const delay = 250

    this.setupVerticalLinks()
    //window.addEventListener('resize', this.setupVerticalLinks)
    window.addEventListener('resize', function() {
      el.style.display = 'none'
      // clear the timeout
      clearTimeout(timeout);
      // start timing for event "completion"
      timeout = setTimeout(_this.setupVerticalLinks, delay);
    });
  }

  render() {
    return (
      <VerticalLink>
        <FadeIn>
          {/* <NavLink style={{marginRight:'100px'}} to='/who-we-are'>Who we are</NavLink> */}
          <MailToLink email={config.helloEmail} />
        </FadeIn>
      </VerticalLink>
    );
  }
}

const Sidebar = () => (
  <StyledAside>
    <Link to='/'><Logo id='logo' src={logo} alt='First Principle logo' /></Link>
    <VerticalLinksComponent />
  </StyledAside>
)

export default Sidebar


// WEBPACK FOOTER //
// ./src/components/Sidebar.js